export const SnackbarSlideDuration = 200;
